import {IFilter} from '@toolify/server/src/services/FilterService/types/IFilter'
import {FilterItemType} from '@toolify/server/src/services/FilterService/enum/FilterItemType'
import {FilterPropertyOperator} from '@toolify/server/src/services/FilterService/enum/FilterPropertyOperator'
import {FilterPropertyPayloadType} from '@toolify/server/src/services/FilterService/enum/FilterPropertyPayloadType'
import {
  IDatePropertyTypeFullValue,
} from '@toolify/server/src/services/DatabasePropertyService/strategies/ColumnTypeStrategies/DatePropertyTypeStrategy/types/IDatePropertyTypeInterfaces'

interface IDateBucketGroupFilterSubProperties {
  rangeSubProperty: string
  emptySubProperty: string
}

export function buildDateBucketGroupFilter(
  group: string,
  value: unknown,
  {rangeSubProperty, emptySubProperty}: IDateBucketGroupFilterSubProperties,
): IFilter {
  const dateValue = value as IDatePropertyTypeFullValue | null
  if(!dateValue || !dateValue.from?.date) {
    return {
      type: FilterItemType.Property,
      id: group,
      subProperty: emptySubProperty,
      operator: {
        type: FilterPropertyOperator.Empty,
      },
      payload: {
        type: FilterPropertyPayloadType.Static,
        value: null,
      },
      isDisabled: false,
    }
  }
  const startDate = dateValue.from.date
  const endDate = dateValue.to?.date ?? dateValue.from.date
  return {
    type: FilterItemType.Property,
    id: group,
    subProperty: rangeSubProperty,
    operator: {
      type: FilterPropertyOperator.BetweenDates,
    },
    payload: {
      type: FilterPropertyPayloadType.Static,
      value: [
        {
          date: startDate,
          time: null,
        },
        {
          date: endDate,
          time: null,
        },
      ],
    },
    isDisabled: false,
  }
}
